import { render, staticRenderFns } from "./MessageNewDetalis.vue?vue&type=template&id=36b6a63b&scoped=true&"
import script from "./MessageNewDetalis.vue?vue&type=script&lang=js&"
export * from "./MessageNewDetalis.vue?vue&type=script&lang=js&"
import style0 from "./MessageNewDetalis.vue?vue&type=style&index=0&id=36b6a63b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6a63b",
  null
  
)

export default component.exports